import Exception from './Exception'

export default class IndexOutOfBoundsException extends Exception { }